import { store } from '../store'

export default (to, from, next) => {
  if (!store.getters.user || !store.getters.company) {
    next()
  } else {
    next('/')
  }
}



// WEBPACK FOOTER //
// ./src/router/NotAuthGuard.js